// extracted by mini-css-extract-plugin
export default {"keyboardShortcut":"keyboardShortcut__OYZ3u7","iconButton":"iconButton__DESUvD"};